import { Button, Icon, IconButton, makeStyles, Theme } from '@material-ui/core';
import { useScreenSizeCheck } from '@moderepo/mode-app-components';
import { Entity } from '@moderepo/mode-internal-apis';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { EntityBreadcrumbBar } from '../../components';
import { useRitzTranslation } from '../../utils/customHooks';
import { useSelectProject } from '../../utils/dataStateHooks';


const useStyle = makeStyles((theme: Theme) => {

    return {
        root: {
            width         : '100%',
            display       : 'flex',
            flexDirection : 'row',
            alignItems    : 'center',
            justifyContent: 'space-between',
            flexWrap      : 'wrap',
        },

        rightActionsBar: {
            display       : 'flex',
            flexDirection : 'row',
            alignItems    : 'center',
            justifyContent: 'flex-end',
            flex          : 1,
        },

        rightButton: {
            textTransform: 'capitalize',
            whiteSpace   : 'nowrap',
        },

        [theme.breakpoints.up('md')]: {
            rightButton: {
                marginLeft: theme.spacing(2),
            },
        },
    };
}, { name: 'EntityDetailsBreadcrumbBar', index: 1 });



export interface EntityDetailsBreadcrumbBarProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly projectId: number;

    readonly onGoHomeClick?: (()=> void) | undefined;

    readonly entitiesBreadcrumbs: readonly Entity[];
    readonly onGotoEntity: (entity: Entity)=> void;

    readonly showEntitiesTreeButton?: boolean | undefined;
    readonly onShowEntitiesTreeButtonClick?: (()=> void) | undefined;

    readonly showEntityInfoButton?: boolean | undefined;
    readonly onShowEntityInfoButtonClick?: (()=> void | undefined);

    readonly showEntitySubscriptionButton?: boolean | undefined;
    readonly onShowEntitySubscriptionButtonClick?: (()=> void | undefined);
}


export const EntityDetailsBreadcrumbBar: React.FC<EntityDetailsBreadcrumbBarProps> = (props: EntityDetailsBreadcrumbBarProps) => {

    const project = useSelectProject(props.projectId);
    const { trans } = useRitzTranslation(project);
    const classes = useStyle();
    const isTabletOrLarger = useScreenSizeCheck('md');

    return (
        <div className={clsx(props.className, classes.root)}>
            <EntityBreadcrumbBar
                entitiesBreadcrumbs={props.entitiesBreadcrumbs}
                onGoHomeClick={props.onGoHomeClick}
                onGotoEntity={props.onGotoEntity}
            />

            <div className={classes.rightActionsBar}>
                {props.showEntitiesTreeButton && (
                    <>
                        {isTabletOrLarger ? (
                            <Button
                                className={clsx(classes.rightButton)}
                                variant="contained"
                                color="default"
                                startIcon={<Icon>account_tree</Icon>}
                                onClick={props.onShowEntitiesTreeButtonClick}
                            >
                                {trans('label.finder')}
                            </Button>
                        ) : (
                            <IconButton
                                className={classes.rightButton}
                                onClick={props.onShowEntitiesTreeButtonClick}
                            >
                                <Icon>account_tree</Icon>
                            </IconButton>
                        )}
                    </>
                )}

                {props.showEntitySubscriptionButton && (
                    <>
                        {isTabletOrLarger ? (
                            <Button
                                className={clsx(classes.rightButton)}
                                variant="contained"
                                color="default"
                                startIcon={<Icon>list</Icon>}
                                onClick={props.onShowEntitySubscriptionButtonClick}
                            >
                                {isTabletOrLarger && trans('entity.action.show_subscriptions')}
                            </Button>
                        ) : (
                            <IconButton
                                className={classes.rightButton}
                                onClick={props.onShowEntitySubscriptionButtonClick}
                            >
                                <Icon>list</Icon>
                            </IconButton>
                        )}
                    </>
                )}

                {props.showEntityInfoButton && (
                    <>
                        {isTabletOrLarger ? (
                            <Button
                                className={clsx(classes.rightButton)}
                                variant="contained"
                                color="default"
                                startIcon={<Icon>info</Icon>}
                                onClick={props.onShowEntityInfoButtonClick}
                            >
                                {isTabletOrLarger && trans('label.info')}
                            </Button>
                        ) : (
                            <IconButton
                                className={classes.rightButton}
                                onClick={props.onShowEntityInfoButtonClick}
                            >
                                <Icon>info</Icon>
                            </IconButton>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
